export const textFieldStyles = {
  width: '100%',
  margin: '10px 0 20px',
};
